import store from "@/store";

let show = () => {
  store.commit('setLoading', true)
};
let hide = () => {
  store.commit('setLoading', false)
};

export default {
  show,
  hide
}